'use strict';
/**
 * QualifierBits->Number
 *
 * Turns a minimized blocking code
 * hex string into a number.
 * If a valid number can not be
 * parsed it returns -1
 *
 * @param qualifierBits - String
 * @returns {Number}
 */
export function extractBlockingCode (qualifierBits) {
  if (qualifierBits === '000000000000' || qualifierBits === '0') return 0;
  const hexcode = qualifierBits.substring(0, qualifierBits.length - 4);
  const result  = parseInt(hexcode, 16);
  return  isNaN(result) ? -1 : result;
}

/**
 * ExtendedSeatData []->String []
 *
 * Converts an array of extracted seat data into an
 * array of blocking codes
 *
 * @param array - Array with extracted seat data
 * @returns {Array}
 */
export function extendedSeatDataToArray (array) {
  let nestedResult = array
    .map(e => e.textContent) // we grab the text content in the xml element
    .map(data => {
      let result = [];
      let dataArray = data.split(','); // the data has the format ######,#
      let count = parseInt(dataArray[1]); // the last character should always be a number
      /*
        count now represents the amount of seats that has the provided seat data
        so we want to add that data as many times as count to our nestedResult array.
       */
      for (let i = 0; i < count; i++) {
        result.push(dataArray[0]);
      }

      return result;
    });
  // Now we flatmap the nested array and should have an array with seat data
  return Array.prototype.concat.apply([], nestedResult);
}

/**
 * String->String []->String->QualifierBits->Boolean
 *
 * https://contegixapp1.livenation.com/confluence/display/MFX/Ism+MNX+backend+CHECKOUT+integration+(with+blocking+codes):+EVENT+-+B2C
 *
 * To determine if a seat is available
 *
 * @param priceCategories - Array
 * @param priceCategory - String
 * @param qualifierBits - String
 * @param blockingCodes - Array
 * @param blockingCode - Integer
 * @returns {boolean}
 */
export function seatIsAvailable (priceCategories, priceCategory, qualifierBits, blockingCodes, blockingCode) {
  blockingCodes = Array.isArray(blockingCodes) ? blockingCodes : [];
  if (blockingCode >= 1024) return false; // Everything from this number and above can be considered as not available
  if (qualifierBits === '1E') return false; // Seat is held (somebody is in the process of purchasing it)
  if (blockingCodes.indexOf(blockingCode) === -1) return false; // blockingCodes always contains a number, 0 if no blocking codes are available
  return priceCategories.indexOf(priceCategory) !== -1;
}



// WEBPACK FOOTER //
// ./frontend/react/sim/parser-mnx-availability/utils/seatUtils.js